module.exports = __webpack_public_path__ + "img/figure-5.0f4b2cb6.png";